export function formatCatalogMoney(value: number, currencyCode: string): string {
  const normalizedCurrency = currencyCode.toUpperCase();

  return new Intl.NumberFormat("es-BO", {
    currency: normalizedCurrency,
    maximumFractionDigits: shouldShowDecimals(normalizedCurrency) ? 2 : 0,
    minimumFractionDigits: shouldShowDecimals(normalizedCurrency) ? 2 : 0,
    style: "currency",
  })
    .format(value)
    .replace("BOB", "Bs")
    .replace(/\s+/g, "");
}

function shouldShowDecimals(currencyCode: string): boolean {
  return currencyCode !== "BOB";
}
